import { Component, Inject, Prop, Watch } from "vue-property-decorator";
import Vue from "vue";
import Vuetify from "vuetify";
import { STYLE_CLASSES } from "@/shared/constants/StyleConstants";
import {
  COLLECTIONS_NAME,
  FORM_CONSTANTS,
  FORM_MESSAGES,
  FORM_VALIDATORS,
  ICON_LIST_FIXED
} from "@/shared/constants/FormConstants";
import Snackbar from "@/shared/components/Snackbar/Snackbar";
import { Utils } from "@/shared/utils/utils";
import {
  COMPONENETS_IDS,
  EMIT_ACTION_PLAN_TEMPLATE_EVENTS,
  EMPTY_SECTION,
  LABELS_ADD_ACTIONPLAN_FORM,
  LABELS_DATATYPE,
  TEMPLATEPDF_CONSTANTS,
  TEMPLATEPDF_MESSAGES,
  PDFTEMPLATES_TYPES,
  TEMPLATE_PDF_ACCESS
} from "../../constants/TemplatePdfConstants";
import ModalTemplate from "@/shared/components/ModalTemplate/ModalTemplate.vue";
import { TemplatePdf } from "../../Models/templatePdf";
import "firebase/storage";
import { TemplatePdfService } from "../../services/templatePdfService";
import { FORM_TEMP_CONSTANTS } from "@/modules/FormTemplate/constants/FormTemplateConstants";
import { LabelPdf } from "../../Models/labelsPdf";
import { GENERAL_CONSTANTS } from "@/shared/constants/GeneralConstants";
import { PdfTemplateSection } from "../../Models/sectionsPdf";
import { ADD_TOOLTIP } from "@/modules/Dashboards/AdminDashboard/constants/AdminDashboardConstants";
import { Icon } from "@/shared/models/Icon";
import AddLabelActionPlan from "./AddLabel/addLabel.vue";
import AddSectionActionPlan from "./AddsSection/AddSection.vue";
import ShowSectionsActionPlan from "./ShowSections/ShowSections.vue";
import { Http } from "@status/codes";
import _ from "lodash";
import { AxiosError } from "axios";

Vue.use(Vuetify);
@Component({
  name: "SaveActionTemplatePdf",
  components: {
    ModalTemplate,
    AddLabelActionPlan,
    AddSectionActionPlan,
    ShowSectionsActionPlan
  }
})
export default class SaveActionTemplatePdf extends Vue {
  @Inject() templatePdfService!: TemplatePdfService;
  @Prop() isModal!: boolean;
  @Prop() idTemplateProp!: string;
  @Prop() templateToEdit!: TemplatePdf;

  currentIcon = GENERAL_CONSTANTS.ICONS.ADD;
  iconBtnClass = STYLE_CLASSES.ICON_BTN;
  textFieldClass = STYLE_CLASSES.TEXT_FIELD;
  PAGE_START = FORM_CONSTANTS.BUTTON.PAGE_START;
  CANCEL = FORM_CONSTANTS.BUTTON.CANCEL;
  SAVE_BTN = FORM_CONSTANTS.BUTTON.SAVE;
  ADD_FIELD_BTN = FORM_TEMP_CONSTANTS.BUTTON.ADD_FIELD;
  CANCEL_BTN = FORM_CONSTANTS.BUTTON.CANCEL;
  primaryBtnClassRound = STYLE_CLASSES.PRIMARY_ROUND_BTN;
  btnClassTertiary = STYLE_CLASSES.TERTIARY_ROUND_BTN;
  secBtnClass = STYLE_CLASSES.SECONDARY_BTN;
  terBtnClass = STYLE_CLASSES.TERTIARY_BTN;
  ADD_TOOLTIP = ADD_TOOLTIP;
  requiredField = [
    FORM_VALIDATORS.REQUIRED_FIELD,
    FORM_VALIDATORS.NOT_BLANK_SPACES_VALIDATOR
  ];
  LABEL_DATATYPE = LABELS_DATATYPE;
  ADD_LABEL_TITLE = LABELS_ADD_ACTIONPLAN_FORM;
  idTemplateEdit = "";
  isEditTemplate = false;
  iconsList: Icon[] = ICON_LIST_FIXED;
  dialogOptions = false;
  indexEditing = -1;
  cardClass = STYLE_CLASSES.CARD;
  modalTitle = FORM_MESSAGES.SAVE_MODAL.TITLE;
  modalText = FORM_MESSAGES.SAVE_MODAL.MESSAGE;

  dialog = false;
  validSection = false;
  addNewSection = true;
  cleanAddSection = false;
  sectionToEdit: PdfTemplateSection = _.cloneDeep(EMPTY_SECTION);
  canSave = true;
  COMPONENETS_IDS = COMPONENETS_IDS;

  formData: TemplatePdf = {
    name: "",
    businessDetails: [
      { logo: true },
      { nit: true },
      { phone: true },
      { companyName: true },
      { address: true }
    ],
    state: true,
    type: PDFTEMPLATES_TYPES.ACTION_PLAN,
    headerExtraInfo: [],
    sections: []
  };
  changeType = true;
  errorsName: string[] = [];
  isValidName = false;
  editComparationStr = "";
  invalidEdit = false;

  async mounted() {
    this.changeTemplate();
  }
  @Watch("idTemplateProp")
  changeTemplate() {
    if (this.idTemplateProp) {
      this.getTemplatePdfById(this.templateToEdit, this.idTemplateProp);
      this.isEditTemplate = true;
    } else {
      this.openDialogOptions();
      this.isEditTemplate = false;
    }

    if (!this.isModal) {
      this.goToStart("saveActionTemplateForm");
    }
  }
  @Watch("changeType")
  changeTemplateType() {
    if (!this.changeType) {
      this.$emit(EMIT_ACTION_PLAN_TEMPLATE_EVENTS.CHANGE_TEMPLATE_TYPE);
      this.changeType = true;
    }
  }

  @Watch("formData", { deep: true })
  checkEdit() {
    if (this.isEditTemplate) {
      this.invalidEdit =
        JSON.stringify(this.formData) === this.editComparationStr;
    }
  }

  async save() {
    if (this.isEditTemplate) {
      this.modalTitle = FORM_MESSAGES.SAVE_MODAL.TITLE;
      this.modalText = FORM_MESSAGES.SAVE_MODAL.MESSAGE;
      this.dialog = true;
    } else {
      const DATAFORM = this.formData;
      if (DATAFORM.name == "") {
        Snackbar.popError(TEMPLATEPDF_CONSTANTS.REFERENCES_TEXTS.REQUIRE_NAME);
        return;
      }

      this.modalTitle = FORM_MESSAGES.SAVE_MODAL.TITLE;
      this.modalText = FORM_MESSAGES.SAVE_MODAL.MESSAGE;
      this.dialog = true;
    }
  }
  goToStart(id: string) {
    Utils.scrollToElement(id, this);
  }

  cancel(): void {
    this.$emit(TEMPLATEPDF_CONSTANTS.REFERENCES_TEXTS.CLOSE_MODAL);
  }
  addNewField(section: PdfTemplateSection) {
    if (this.sectionToEdit.title !== "") {
      this.replaceSection(section, this.sectionToEdit);
      return;
    }
    const repeatName = this.formData.sections?.find(
      sectionOnList => sectionOnList.title === section.title
    );
    if (!repeatName) {
      this.formData.sections?.push(_.cloneDeep(section));
      this.cleanAddSectionComponent();
      this.canSave = true;
    } else {
      Snackbar.popInfo(TEMPLATEPDF_MESSAGES.SECTION_REPEAT_NAME);
    }
  }
  addNewLabel(label: LabelPdf) {
    const repeatName = this.formData.headerExtraInfo?.find(
      labelOnList => labelOnList.title == label.title
    );

    if (label.title !== "" && label.valueType !== "" && !repeatName) {
      this.formData.headerExtraInfo?.push(_.cloneDeep(label));
    } else {
      Snackbar.popInfo(TEMPLATEPDF_MESSAGES.LABEL_REPEAT_NAME);
    }
  }
  removeLabel(label: LabelPdf) {
    const index = this.formData.headerExtraInfo?.findIndex(
      labelOnList => labelOnList == label
    );
    if (index !== undefined && index !== -1) {
      this.formData.headerExtraInfo?.splice(index, 1);
    }
  }
  cleanAddSectionComponent() {
    this.cleanAddSection = true;
    this.sectionToEdit = _.cloneDeep(EMPTY_SECTION);
  }
  closeAddSection() {
    if (this.formData.sections && this.formData.sections?.length > 0) {
      this.sectionToEdit = _.cloneDeep(EMPTY_SECTION);
      this.addNewSection = false;
      this.canSave = true;
      this.cleanAddSection = false;
    } else {
      Snackbar.popInfo(TEMPLATEPDF_MESSAGES.ONE_SECTION_REQUIRED);
    }
  }
  editSection(section: PdfTemplateSection) {
    this.sectionToEdit = { ...section };
    this.addNewSection = true;
    this.goToStart(this.COMPONENETS_IDS.ADD_SECTION);
  }
  removeSection(section: PdfTemplateSection) {
    const findSectionIndex = this.formData.sections?.findIndex(
      sectionOnList => sectionOnList.title == section.title
    );
    if (findSectionIndex != undefined && findSectionIndex !== -1) {
      this.formData.sections?.splice(findSectionIndex, 1);
    }
    if (this.formData.sections && this.formData.sections.length <= 1) {
      this.openAddSection();
    }
  }
  openAddSection() {
    this.addNewSection = true;
    this.sectionToEdit = _.cloneDeep(EMPTY_SECTION);
    this.canSave = false;
    this.goToStart(this.COMPONENETS_IDS.ADD_SECTION);
  }
  async handleModalAccept() {
    this.dialog = false;
    if (this.modalTitle === FORM_MESSAGES.SAVE_MODAL.TITLE) {
      await this.doIfOk();
    }
    if (this.modalTitle === FORM_MESSAGES.CANCEL_MODAL.TITLE) {
      if (this.isModal) {
        this.$emit(TEMPLATEPDF_CONSTANTS.REFERENCES_TEXTS.CLOSE_MODAL);
      } else {
        this.$emit(TEMPLATEPDF_CONSTANTS.REFERENCES_TEXTS.SAVE_TEMPLATE);
      }
    }
  }
  async doIfOk() {
    try {
      if (this.isEditTemplate) {
        const responseData = await this.templatePdfService.updateTemplate(
          this.formData,
          this.idTemplateEdit
        );
        if (responseData.code == Http.Ok) {
          Snackbar.popSuccess(TEMPLATEPDF_MESSAGES.SAVED_SUCCESSFULLY);
          this.formData = {
            name: "",
            businessDetails: [
              { logo: true },
              { nit: true },
              { phone: true },
              { companyName: true },
              { address: true }
            ],
            state: true,
            type: PDFTEMPLATES_TYPES.ACTION_PLAN,
            headerExtraInfo: [],
            sections: []
          };

          if (this.isModal) {
            this.$emit(TEMPLATEPDF_CONSTANTS.REFERENCES_TEXTS.CLOSE_MODAL);
          } else {
            this.$emit(TEMPLATEPDF_CONSTANTS.REFERENCES_TEXTS.SAVE_TEMPLATE);
          }
        } else {
          Snackbar.popError(responseData.message);
        }
      } else {
        const responseData = await this.templatePdfService.saveTemplate(
          this.formData
        );

        if (responseData.code == Http.Ok) {
          if (this.isModal) {
            this.$emit(TEMPLATEPDF_CONSTANTS.REFERENCES_TEXTS.CLOSE_MODAL);
          } else {
            this.$emit(TEMPLATEPDF_CONSTANTS.REFERENCES_TEXTS.SAVE_TEMPLATE);
          }
        } else {
          Snackbar.popError(responseData.message);
        }
      }
    } catch (error) {
      const METHOD = Utils.getMethodHTTP(
        error as AxiosError
      ) as keyof typeof TEMPLATE_PDF_ACCESS;
      const errorMessage =
        (error as Error).message === GENERAL_CONSTANTS.FORBIDDEN
          ? `${FORM_MESSAGES.FORBIDDEN_REQUEST}${TEMPLATE_PDF_ACCESS[METHOD]}`
          : FORM_MESSAGES.REQUEST_FAILED;

      Snackbar.popError(errorMessage);
    }
  }
  handleModalCancel() {
    this.dialog = false;
  }
  getTemplatePdfById(template: TemplatePdf, id: string) {
    this.idTemplateEdit = id;
    this.formData.name = template.name;
    this.formData.businessDetails = template.businessDetails;
    this.formData.headerExtraInfo = template.headerExtraInfo;
    this.formData.sections = template.sections;

    this.isValidName = this.formData.name != "" ? true : false;
    this.editComparationStr = JSON.stringify(this.formData);
  }
  openDialogOptions() {
    this.dialogOptions = true;
    this.indexEditing = -1;
  }
  replaceSection(
    section: PdfTemplateSection,
    sectionToReplace: PdfTemplateSection
  ) {
    const findSectionIndex = this.formData.sections?.findIndex(
      sectionOnList => sectionOnList.title == sectionToReplace.title
    );
    if (findSectionIndex != undefined && findSectionIndex !== -1) {
      this.formData.sections?.splice(findSectionIndex, 1, section);
      this.canSave = true;
    }
    if (this.formData.sections && this.formData.sections.length <= 1) {
      this.openAddSection();
    }
    this.cleanAddSectionComponent();
  }

  async validateUniqueName() {
    this.errorsName = await Utils.checkUniqueName(
      COLLECTIONS_NAME.TEMPLATES_PDF,
      this.formData.name
    );
    this.isValidName = !(this.errorsName.length > 0);
  }
}
